export default {
  /**
   * @type {string} *
   * @description 系统标题
   */
  Title: "广西民族剧院",

  /**
   * @type {string} *
   * @description 版权公司
   */
  copyrightCompany: "-",

};
